export default {
    computed: {
        /**
         * Devuelve el atributo key
         * @return {*} String
         */
        key() {
            return this.$vnode.key;
        }
    }
};
